<ui-card type="raised" *ngIf="topicsCount">
    <card-body class="article-filters">
        <nav ui-list size="lg" [highlights]="true" class="unbordered">
            <ui-list-item role="header"><span class="strong">{{'privacy.education.topics' | translate}}</span></ui-list-item>
            <a class="d-inline-block" id="a_1597856988_0" href="" ui-list-item [ngClass]="{'active': !activeFilter}" (click)="filterByTopic()">
                {{'privacy.education.all.topics' | translate}}
                (<span [innerHtml]="topicArticlesNumber()"></span>)
            </a>
            <a class="d-inline-block" id="a_1597856988_{{i+1}}" href="" ui-list-item *ngFor="let topic of topics | keyvalue; let i = index;" (click)="filterByTopic(topic.value)" [ngClass]="{'active': activeFilter === topic.value}">
               {{'privacy.education.topic.'+topic.value|translate}}
                (<span [innerHtml]="topicArticlesNumber(topic.value)"></span>)
            </a>
        </nav>
    </card-body>
</ui-card>
